import { getPaymentHistoryStatusPresentation } from '../hostedReturn';

export type PaymentStatusPillProps = {
  status: unknown;
};

export function PaymentStatusPill({ status }: PaymentStatusPillProps) {
  const presentation = getPaymentHistoryStatusPresentation(status);
  return (
    <span
      data-testid="payment-status-pill"
      data-payment-status-tone={presentation.tone}
      data-payment-status-label={presentation.label}
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${presentation.className}`}
    >
      {presentation.label}
    </span>
  );
}
